import { render, staticRenderFns } from "./InvestWithDrivewealthWidget.vue?vue&type=template&id=11dd6afa&scoped=true"
import script from "./InvestWithDrivewealthWidget.vue?vue&type=script&lang=ts"
export * from "./InvestWithDrivewealthWidget.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11dd6afa",
  null
  
)

export default component.exports